export enum StructureType {
  SURFACE_WATER = 'SURFACE_WATER',
  GROUNDWATER = 'GROUNDWATER',
  CONDUCT = 'CONDUCT',
}
